import { render, staticRenderFns } from "./CPMDashboard.vue?vue&type=template&id=7b1cdf19&scoped=true&"
import script from "./CPMDashboard.vue?vue&type=script&lang=js&"
export * from "./CPMDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CPMDashboard.vue?vue&type=style&index=0&id=7b1cdf19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1cdf19",
  null
  
)

export default component.exports